import React, { memo, useRef, useEffect, useState } from "react";
import Banner from "../Banner";
import useMode from "../../hooks/useMode";
import useData from "../../hooks/useData";
import OrderConfirmation from "../OrderConfirmation";
import ProductView from "../ProductView";
import WidgetCard from "../WidgetCard";
import scrollTo from "../../utils/scrollTo";
import { MODES } from "../../conf";
import useDimensions from "../../hooks/useDimensions";
import useExperience from "../../hooks/useExperience";
import { WidgetMainWrapper } from "../Widget";

import accessibilityProvider from "../../utils/accessibilityProvider";
import message from "../../utils/message";
import { MESSAGE_TYPES } from "../../hooks/useMessage";
import { genClassName } from "@disco/disco_core";

import "./widget-main.css";
import "./widget-main-compact.css";

const WidgetMain = memo(() => {
	const widgetRef = useRef(null);
	const targetScrollRef = useRef(null);
	const [widgetStyles, setWidgetStyles] = useState({});
	const { inPPE, mode } = useMode();
	const { inDesktopOnly } = useDimensions();

	const { canTrack } = useData();

	const { shouldIncreaseImpressions } = useExperience();

	useEffect(() => {
		if (!canTrack || !inPPE || mode !== MODES.FULLSCREEN || inDesktopOnly) {
			return;
		}
		const parent = document.documentElement;
		setTimeout(() => {
			scrollTo({
				parent,
				target: targetScrollRef.current,
				stopAtTargetZero: true,
				onEnd: () => message(MESSAGE_TYPES.REQUEST_PARENT_STATS),
			});
		}, 1000);
	}, [inPPE, canTrack, mode, inDesktopOnly]);

	return (
		<>
			{inPPE && (
				<>
					<Banner ref={targetScrollRef} />
					<OrderConfirmation />
				</>
			)}
			<WidgetMainWrapper
				style={widgetStyles}
				className={genClassName({
					base: "widget-main",
					conditionals: {
						"widget-main-expanded": shouldIncreaseImpressions,
					},
				})}
				{...accessibilityProvider({
					name: "widget main",
				})}
			>
				<WidgetCard setWidgetStyles={setWidgetStyles} />
				<ProductView widgetRef={widgetRef} />
			</WidgetMainWrapper>
		</>
	);
});
export default WidgetMain;
